import { ETaskId } from 'common/contracts';
import { EPermissionGroup, IPermissions } from 'common/permissions.types';
import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

export const checkTaskPermission = (taskId: ETaskId, publisherId: string): boolean => {
  const permissions = localStorageUtil.get<IPermissions>(ELocalStorageKeys.PERMISSIONS);

  if (!permissions || !publisherId) return false;

  const taskPermissionMap: Record<string, EPermissionGroup[]> = {
    // Builder tasks
    [ETaskId.CUSTOMIZE_GENERAL_STORE_SETTINGS]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_STORE_PAGE]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_CHECKOUT]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_SUCCESS_PAGE]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_LOGIN_PAGE]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_STORE_LAYOUT]: [EPermissionGroup.BUILDER],
    [ETaskId.CUSTOMIZE_RECEIPT]: [EPermissionGroup.BUILDER],
    
    // Integration tasks
    [ETaskId.CUSTOMIZE_AUTH_API]: [EPermissionGroup.INTEGRATION],
    [ETaskId.SETUP_AWARD_API]: [EPermissionGroup.INTEGRATION],
    [ETaskId.SETUP_PERSONALIZATION_API]: [EPermissionGroup.INTEGRATION],
    
    // Authentication tasks
    [ETaskId.CONFIGURE_SIGNIN_METHODS]: [EPermissionGroup.AUTHENTICATION],
    
    // Product/Offer tasks
    [ETaskId.CREATE_FIRST_PRODUCT]: [EPermissionGroup.PRODUCTS],
    [ETaskId.CREATE_OFFER_DESIGN]: [EPermissionGroup.OFFERS],
    [ETaskId.ACTIVATE_FIRST_BUNDLE]: [EPermissionGroup.OFFERS],
    
    // Pricing tasks
    [ETaskId.CREATE_PRICE_POINTS]: [EPermissionGroup.PRICING],
    [ETaskId.USE_GET_PRICE_POINTS]: [EPermissionGroup.PRICING],
    
    // Company tasks
    [ETaskId.CUSTOMIZE_YOUR_DOMAIN]: [EPermissionGroup.COMPANY],
  };

  const requiredPermissions = taskPermissionMap[taskId];
  if (!requiredPermissions) return true; 
 
  return requiredPermissions.every(permission => 
    permissions[publisherId]?.[permission]?.includes('manage')
  );
};
